var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            " " + _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Basic")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("backText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      [
        _c(
          "el-row",
          [
            _c("div", { staticClass: "bj-row mt10 mb10" }, [
              _c("div", { staticClass: "bj-col-11" }, [
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("BusinessAfterCsgReturn.main.totalQty"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.planQty)),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("ReturnOrderText")) +
                        _vm._s(_vm.$t("goodsBrand.page.Status"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(_vm.RETURN_ORDER_STATUS.bjGet(_vm.form.status))
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("BusinessAfterCsgReturn.main.backInventoryQty")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.backInventoryQty)),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BusinessAfterCsgReturn.main.backInventoryRemark"
                        )
                      )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bj-form-item-value" },
                    [
                      _c("BjTextarea", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.backInventoryRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "backInventoryRemark", $$v)
                          },
                          expression: "form.backInventoryRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bj-col-1" }),
              _c("div", { staticClass: "bj-col-12" }, [
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BusinessPurchaseOrderDetail.table.associatedCode"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.thirdCode)),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("BusinessAfterCsgReturn.table.reference"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.remark)),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("BusinessAfterCsgReturn.main.damagedQty"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.damagedQty)),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("BusinessAfterCsgReturn.main.damagedRemark")
                      )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bj-form-item-value" },
                    [
                      _c("BjTextarea", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.damagedRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "damagedRemark", $$v)
                          },
                          expression: "form.damagedRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("BjDivider", [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("BusinessPurchaseComponentsPur.information")) +
                  " "
              ),
            ]),
            _c(
              "el-table",
              {
                attrs: {
                  data: [_vm.form],
                  border: "",
                  script: "",
                  "max-height": "600",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BjDialogListConfig.SKUcode"),
                    prop: "standardSkuCode",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BjDialogListConfig.SKUname"),
                    prop: "skuName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessAfterCsgReturn.main.totalQty"),
                    prop: "planQty",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessAfterCsgReturn.table.backInventoryQty"
                    ),
                    prop: "backInventoryQty",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessAfterCsgReturn.table.backInventoryRemark"
                    ),
                    prop: "backInventoryRemark",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessAfterCsgReturn.table.damagedQty"),
                    prop: "damagedQty",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessAfterCsgReturn.table.damagedRemark"),
                    prop: "damagedRemark",
                    align: "center",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("BusinessAfterCsgReturn.pictureMsg"))),
      ]),
      _c("div", { staticClass: "mt20" }, [
        _c(
          "div",
          { staticClass: "flex" },
          _vm._l(
            _vm.form.thirdPartyReturnOrderMaterialList,
            function (imageUrl, index) {
              return _c(
                "div",
                { key: index, staticClass: "imageViewer" },
                [
                  _c("BjKeyImage", {
                    staticStyle: { margin: "10px" },
                    attrs: {
                      height: "148px",
                      width: "148px",
                      url: _vm.normalizeDownloadUrl(imageUrl.detailImage),
                      preview: "",
                    },
                  }),
                  _c("div", { staticClass: "flex flex-spacearound" }, [
                    _c("i", {
                      staticClass: "el-icon-download yellow",
                      on: {
                        click: function ($event) {
                          return _vm.downloadImage(imageUrl.detailImage)
                        },
                      },
                    }),
                    !_vm.$store.getters.cusId
                      ? _c("i", {
                          staticClass: "el-icon-delete red",
                          on: {
                            click: function ($event) {
                              return _vm.deleteImage(imageUrl.detailImage)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                ],
                1
              )
            }
          ),
          0
        ),
      ]),
      !_vm.$store.getters.cusId
        ? [
            _c(
              "el-row",
              [
                _c("BjDivider", [
                  _vm._v(
                    _vm._s(_vm.$t("InternalReturnRefundNoteDetails.Upload")) +
                      _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Picture"))
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "mt20" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { display: "block", height: "100%" },
                        attrs: { label: "" },
                      },
                      [
                        _c(
                          "BjUpload",
                          {
                            ref: "BjUpload",
                            staticClass: "avatar-uploader",
                            attrs: {
                              limit: 20,
                              "limit-size": 5 * 1024,
                              multiple: "",
                              "show-file-list": "",
                              "list-type": "picture-card",
                              accept: "image/png,image/jpeg",
                              "accept-list": ["image/jpeg", "image/png"],
                              "auto-upload": "",
                              "limit-hide": "",
                            },
                            on: {
                              afterUpload: _vm.afterUpload,
                              remove: _vm.onRemoveUrl,
                            },
                          },
                          [
                            _c("template", { slot: "default" }, [
                              _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                            ]),
                            _c("template", { slot: "tip" }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Comment" } },
                      [
                        _c("BjTextarea", {
                          attrs: {
                            maxlength: 999,
                            placeholder: _vm.$t("inputText"),
                          },
                          model: {
                            value: _vm.comment,
                            callback: function ($$v) {
                              _vm.comment = $$v
                            },
                            expression: "comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-row", [
              _c(
                "div",
                { staticClass: "text-center mt20 mb20" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "150px" },
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancelText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.onConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }